<template>
    <div class="main">
        <ul class="content">
            <li v-for="item in clayList" :key="item.id"  @click="showMask">
                <img :src="item.imgSrc" alt="">
                <span>
                    {{item.title}}
                </span>
                <span>{{item.price}}</span>
            </li>
        </ul>
        <common-mask v-if="isMask" @closeMask="closeMask"></common-mask>
    </div>
</template>
<script>
import ComtentA from '@/components/useQuestion'
import ComtentB from '@/components/engineering'
import ComtentC from '@/components/sapplication'
import CommonMask from '@/components/mask'
export default {
    name:'clay',
    data() {
        return {
            isMask:false,
            content: '',
            select: '1',
            clayList:[
                {
                    id:'01',
                    imgSrc: require("../../static/img/clay/u62.png"),
                    title:'【崩壞3】芽衣雷電女王的鬼鎧粘土人手辦【全款】',
                    price:'$34.99'
                },
                {
                    id:'02',
                    imgSrc: require("../../static/img/clay/u96.png"),
                    title:'粘土人工藤新一名偵探柯南手辦模型玩具擺件',
                    price:'$30.99'
                },
                {
                    id:'03',
                    imgSrc: require("../../static/img/clay/u97.png"),
                    title:'GSC SE 尼爾 機械紀元 2B 粘土人 寄葉二號B型 手辦',
                    price:'$35.99'
                },
                {
                    id:'04',
                    imgSrc: require("../../static/img/clay/u99.png"),
                    title:'粘土人毛利蘭名偵探柯南手辦模型玩具擺件',
                    price:'$30.99'
                },
                {
                    id:'05',
                    imgSrc: require("../../static/img/clay/u100.png"),
                    title:'GSC 十三機兵防衛圈 冬坂五百里 粘土人現貨',
                    price:'$36.99'
                },
                {
                    id:'06',
                    imgSrc: require("../../static/img/clay/u101.png"),
                    title:'GSC EVA新劇場版 明日香 插入栓服 戰鬥服 粘土人',
                    price:'$36.99'
                },
                 {
                    id:'07',
                    imgSrc: require("../../static/img/clay/u102.png"),
                    title:'GSC 天使降臨到了我身邊 星野日向 粘土人 手辦 動漫 現貨',
                    price:'$36.99'
                },
                {
                    id:'08',
                    imgSrc: require("../../static/img/clay/u103.png"),
                    title:'GSC GSAS 明日方舟 W 粘土人 手辦 現貨',
                    price:'$35.99'
                },
                {
                    id:'09',
                    imgSrc: require("../../static/img/clay/u104.png"),
                    title:'陰陽師酒吞童子粘土人手辦GSC手辦 UUS 網易遊戲官網周邊',
                    price:'$35.99'
                },
                {
                    id:'10',
                    imgSrc: require("../../static/img/clay/u105.png"),
                    title:'陰陽師晴明GSC粘土手辦 網易遊戲印象官方周邊',
                    price:'$35.99'
                },
                {
                    id:'11',
                    imgSrc: require("../../static/img/clay/u107.png"),
                    title:'GSC EVA 劇場版 綾波麗 插入栓服 Ver.粘土人 現貨',
                    price:'$35.99'
                },
                {
                    id:'12',
                    imgSrc: require("../../static/img/clay/u108.png"),
                    title:'GSC 百無禁忌 611 辣妹子 粘土 手辦 現貨',
                    price:'$34.31'
                },
            ]
        }
    },
    components: { ComtentA, ComtentB, ComtentC,CommonMask },
    mounted: function () {},
    methods: {
        selectComponents: function (e) {
            this.select = e
        },
        showMask() {
            this.isMask = true;
        },
        closeMask() {
            this.isMask = false;
        }
    },
    computed: {},
}
</script>
<style lang="css" scoped>
.main {
    width: 100%;
    position: relative;
    top: 0;
    padding-top: 150px;
    background-color: #f3f4f2;
}
.toptab {
    width: 900px;
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
}
.toptab .active {
    border: 1px solid #ef653d;
}
.tabBtn {
    color: #ef653d;
    font-size: 20px;
    font-weight: 600;
    margin-right: 50px;
    padding: 5px 8px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
}
.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
    opacity: 0;
}
.main ul {
    list-style: none;
    width: 1200px;
    margin: 0 auto;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    /**background: pink;**/
}
.main ul li{
    width: 249px;
    height: 350px;
    margin-bottom: 45px;
    overflow: hidden;
    font-size: 14px;
    border:1px solid #d7d7d7;
    cursor: pointer;
}
.main ul li:hover{
    box-shadow:0 0 12px 0 rgba(50,50,50,.2);
}
.main ul li:hover img{
    transform: scale(1.08);
}
.main ul li:hover span{
    color:#ef6549
}
.main ul li img{
    width: 249px;
    height: 249px;
    transition: all .9s;
}
.main ul li span{
    display: block;
}
.main ul li span:nth-of-type(1){
    display: block;
    margin:18px 0 10px;
}
.main ul li span:nth-of-type(2){
    display: block;
    color:#ef6549;
    font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/clay.vue